import { useMealCreditFormData } from 'src/components/oneCorp/features/MealCredit/components/Form/MealCreditDataProvider/MealCreditDataProvider';
import {
  GroupRestrictions,
  groupRestrictions,
  transformEntityItemRestrictions,
} from 'src/common/OrderRestrictions/orderRestrictions.utils';

import {
  useOrderRestrictionContext,
  OrderRestrictionsContextType,
} from 'src/common/OrderRestrictions/OrderRestrictionsProvider/OrderRestrictionsProvider';

type UseMealCreditItemRestrictionsReturn = {
  groupedItemRestrictions: GroupRestrictions;
} & OrderRestrictionsContextType;

export function useMealCreditItemRestrictions(): UseMealCreditItemRestrictionsReturn {
  const { mealCredit } = useMealCreditFormData();
  const { isLoading, itemRestrictionsMeta, error } =
    useOrderRestrictionContext();

  const getGroupedItemRestrictions = (): GroupRestrictions => {
    if (error && mealCredit?.item_restrictions) {
      return groupRestrictions(
        transformEntityItemRestrictions(mealCredit.item_restrictions)
      );
    }

    return groupRestrictions(itemRestrictionsMeta || []);
  };

  return {
    itemRestrictionsMeta,
    isLoading,
    groupedItemRestrictions: getGroupedItemRestrictions(),
  };
}
